import React, { useRef } from 'react'
import Sortable from '@shopify/draggable/lib/es5/sortable'
import { useDeepCompareEffect } from 'ahooks'
import classNames from 'classnames'
import './index.less'

const DRAGGABLE_KEY = 'mn-draggable-item'
const DRAGGABLE_ACTIVE_KEY = 'mn-draggable-item-active'

type IDRAG = {
  data:Array<any>,
  renderItem:any,
  className?:any,
  draggableKey?:string,
  handleKey?:string,
  onStop?:any,
  onSorted?:any,
}

export default ({
  data,
  renderItem, className,
  draggableKey = DRAGGABLE_KEY,
  handleKey = null,
  onStop,
  onSorted,
}:IDRAG) => {
  const $sortWrapper = useRef(null)

  useDeepCompareEffect(() => {
    const container = $sortWrapper.current
    if (container.length === 0) {
      return
    }
    const sortable = new Sortable(container, {
      draggable: `.${draggableKey}`,
      handle: handleKey ? `.${handleKey}` : null,
      mirror: {
        constrainDimensions: true
      },
    })
    const onStart = (result) => {
      result.data.dragEvent.source.classList.add(DRAGGABLE_ACTIVE_KEY)
    }
    const _onSorted = ({ data }) => {
      onSorted?.(data.newIndex, data.oldIndex)
    }
    const _onStop = ({ data }) => {
      onStop?.(data.newIndex, data.oldIndex)
    }
    sortable.on('sortable:start', onStart)
    sortable.on('sortable:sorted', _onSorted)
    sortable.on('sortable:stop', _onStop)
    return () => {
      sortable.off('sortable:start', onStart)
      sortable.off('sortable:sorted', _onSorted)
      sortable.off('sortable:stop', _onStop)
    }
  }, [data])

  return <div ref={$sortWrapper} className={classNames('mn-dragList-wrap', className)}>
    {
        data.map((item, index) => renderItem(item, index, { draggableKey }))
    }
  </div>
}
